var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBrushSolid = function SvgBrushSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 11.969c0-.82.383-1.586 1.04-2.078l6.48-4.868c.492-.382 1.203-.328 1.668.082.464.438.546 1.149.218 1.696l-4.43 6.836a2.686 2.686 0 0 1-1.832 1.175L10.25 11.97Zm2.625 3.719a3.075 3.075 0 0 1-3.063 3.062H5.876A.864.864 0 0 1 5 17.875c0-.465.383-.875.875-.875h.11c.492 0 .82-.492.765-.984v-.328c0-1.641 1.285-2.981 2.926-3.036l3.172 2.844c0 .055.027.137.027.191Z"
  })));
};

export default SvgBrushSolid;